import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pa-sm bg-background",
  style: {"min-height":"inherit"}
}

import { computed, ref } from "vue";
import { tableViewTabOptions } from "@/util";
import { layoutStore } from "@/hooks";
import {
  ArtifactTable,
  PrivatePage,
  TabList,
  TraceTable,
  ProjectTree,
  ApprovalTable,
  ProjectChat,
} from "@/components";


/**
 * Displays the artifact tree and table.
 */
const __default__ = {
  name: "ArtifactView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tabs = tableViewTabOptions();

const tab = ref(tabs[0].id);

const isTableMode = computed(() => layoutStore.isTableMode);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), {
    "full-window": "",
    graph: "",
    class: "bg-neutral"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ProjectTree)),
      _createVNode(_unref(ProjectChat)),
      (isTableMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(TabList), {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              tabs: _unref(tabs)
            }, {
              artifact: _withCtx(() => [
                _createVNode(_unref(ArtifactTable))
              ]),
              trace: _withCtx(() => [
                _createVNode(_unref(ApprovalTable))
              ]),
              matrix: _withCtx(() => [
                _createVNode(_unref(TraceTable))
              ]),
              _: 1
            }, 8, ["modelValue", "tabs"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})